import { Dropdown, Modal, Nav, Placeholder } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
// import NineDotMenu from './NineDotMenu';
import { useAppContext } from 'providers/AppProvider';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import NotificationDropdownMenu from './NotificationDropdownMenu';
import ActivityDropdownMenu from './ActivityDropdownMenu';
import FeedbackNavItem from './FeedbackNavItem';
import WhatsNewNavItem from './WhatsNewNavItem';
import ThemeToggler from 'components/common/ThemeToggler';
import { useState } from 'react';
import DropdownSearchBox from 'components/common/DropdownSearchBox';
import SearchResult from 'components/common/SearchResult';
import classNames from 'classnames';
import EmployeeAvatar from 'components/base/EmployeeGravatar';
import { useQuery, useQueryClient } from 'react-query';
import { getNotificationCounts } from 'services/api/notification';
import Badge from 'components/base/Badge';
import { GET_ME } from 'services/api/employee';
import { Employee } from 'data/users';
import { useNotificationSocket } from 'hooks/useNotificationSocket';
import { useAccessToken } from 'providers/AccessTokenProvider';

const NavItems = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();
  const queryClient = useQueryClient();
  const { authUser } = useAccessToken();
  const [openSearchModal, setOpenSearchModal] = useState<boolean>(false);

  const { data: userData, isLoading: userDataLoading } = useQuery<Employee>(
    'user_profile_data',
    async () => {
      const response = await GET_ME();
      return response.data;
    },
    {
      enabled: Boolean(authUser)
    }
  );

  const { data: countResponse } = useQuery(
    ['notificationCount'],
    getNotificationCounts,
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  );

  useNotificationSocket({
    enabled: Boolean(authUser),
    onNewNotification: () => {
      queryClient.invalidateQueries(['notifications']);
    },
    onNotificationCountUpdate: data => {
      queryClient.setQueryData(['notificationCount'], () => ({
        data: { count: data.count }
      }));
    },
    onNotificationRead: data => {
      console.log('Notification read in navbar:', data);
    },
    onAllNotificationsRead: () => {
      queryClient.setQueryData(['notificationCount'], () => ({
        data: { count: 0 }
      }));
    }
  });

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      <WhatsNewNavItem />
      <FeedbackNavItem />
      {!!userData?.isAdmin && (
        <Nav.Item>
          <Dropdown autoClose="outside" className="h-100">
            <Dropdown.Toggle
              as={Link}
              className="dropdown-caret-none nav-link h-100 position-relative"
            >
              <FeatherIcon icon="activity" size={20} />
            </Dropdown.Toggle>
            <ActivityDropdownMenu />
          </Dropdown>
        </Nav.Item>
      )}
      <Nav.Item
        className={classNames({
          'd-lg-none':
            navbarPosition === 'vertical' || navbarPosition === 'dual'
        })}
      >
        <Nav.Link onClick={() => setOpenSearchModal(!openSearchModal)}>
          <FeatherIcon icon="search" size={19} style={{ marginBottom: 2 }} />
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            className="dropdown-caret-none nav-link h-100 position-relative"
          >
            <FeatherIcon icon="bell" size={20} />
            {Number(countResponse?.data?.count) > 0 && (
              <Badge className="position-absolute top-2 right-0 translate-middle badge rounded-pill">
                {Number(countResponse?.data?.count) > 99
                  ? '99+'
                  : countResponse?.data?.count}
              </Badge>
            )}
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        {/* <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown> */}
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            {userDataLoading ? (
              <div className="avatar avatar-l me-0">
                <div className="avatar-name rounded-circle bg-light d-flex align-items-center justify-content-center text-dark">
                  <Placeholder
                    as="div"
                    animation="glow"
                    className="w-100 h-100"
                  >
                    <Placeholder xs={12} className="h-100" />
                  </Placeholder>
                </div>
              </div>
            ) : (
              <EmployeeAvatar
                src={userData?.profileImage || userData?.email}
                size="l"
              />
            )}
          </Dropdown.Toggle>
          <ProfileDropdownMenu
            profileImage={userData?.profileImage}
            authUser={userData}
          />
        </Dropdown>
      </Nav.Item>

      <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: 'auto' }}
          >
            <SearchResult />
          </DropdownSearchBox>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NavItems;
